import {Directive, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {ControlAccessors, InputModifierService} from "./input-modifier.service";

@Directive({
    selector: '[formGroup][controlName][trim]',
    host: {
        '(focusout)': 'onBlur($event)'
    }
})
export class TrimDirective {
    @Input('controlName') controlName: string;
    @Input('formGroup') form: FormGroup;

    constructor(private _inputModifier: InputModifierService) {
    }

    onBlur(event) {
        this._inputModifier.transformControlValue<string>(ControlAccessors.forReactiveForm(this.form, this.controlName),
            event, this.transform)
    }

    transform(value: string): string {
        if(!value) {
            return null;
        }
        return value.trim();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/trim.directive.ts